import { render, staticRenderFns } from "./user-wizard-namad.vue?vue&type=template&id=b98f9f08&scoped=true&"
import script from "./user-wizard-namad.vue?vue&type=script&lang=js&"
export * from "./user-wizard-namad.vue?vue&type=script&lang=js&"
import style0 from "./user-wizard-namad.vue?vue&type=style&index=0&id=b98f9f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98f9f08",
  null
  
)

export default component.exports